"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _ = require("../../..");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)({
  deployInfoBox: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    display: 'inline-block',
    width: 'fit-content',
    zIndex: 2147483647
  },
  deployInfoTable: {
    '& tr': {
      '& td': {
        width: 'fit-content'
      }
    }
  }
});

var DeploymentInfo = function DeploymentInfo(_ref) {
  var _ref$env = _ref.env,
      env = _ref$env === void 0 ? 'prod' : _ref$env,
      gitBranch = _ref.gitBranch,
      commitAuthor = _ref.commitAuthor,
      commitURL = _ref.commitURL,
      shortCommitHash = _ref.shortCommitHash,
      jiraTicket = _ref.jiraTicket,
      jiraLink = _ref.jiraLink,
      contextComment = _ref.contextComment,
      deploymentTime = _ref.deploymentTime,
      _ref$shouldShowDeploy = _ref.shouldShowDeploymentInfo,
      shouldShowDeploymentInfo = _ref$shouldShowDeploy === void 0 ? false : _ref$shouldShowDeploy;

  var _useState = (0, React.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfo = _useState2[0],
      setShowInfo = _useState2[1];

  var classes = useStyles();
  if (env === 'prod' || !shouldShowDeploymentInfo) return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  return (0, _jsxRuntime.jsx)("div", {
    className: classes.deployInfoBox,
    children: (0, _jsxRuntime.jsxs)(_.Paper, {
      css: {},
      children: [showInfo && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsxs)("table", {
          className: classes.deployInfoTable,
          children: [(0, _jsxRuntime.jsx)("th", {
            children: (0, _jsxRuntime.jsx)("td", {
              children: "Deployment Info"
            })
          }), gitBranch && (0, _jsxRuntime.jsxs)("tr", {
            children: [(0, _jsxRuntime.jsx)("td", {
              children: "Code branch:"
            }), (0, _jsxRuntime.jsx)("td", {
              children: gitBranch
            })]
          }), jiraTicket && (0, _jsxRuntime.jsxs)("tr", {
            children: [(0, _jsxRuntime.jsx)("td", {
              children: "JIRA:"
            }), (0, _jsxRuntime.jsx)("td", {
              children: (0, _jsxRuntime.jsx)("a", {
                href: jiraLink,
                children: jiraTicket
              })
            })]
          }), commitAuthor && (0, _jsxRuntime.jsxs)("tr", {
            children: [(0, _jsxRuntime.jsx)("td", {
              children: "Deployed by:"
            }), (0, _jsxRuntime.jsx)("td", {
              children: commitAuthor
            })]
          }), deploymentTime && (0, _jsxRuntime.jsxs)("tr", {
            children: [(0, _jsxRuntime.jsx)("td", {
              children: "Deployed at:"
            }), (0, _jsxRuntime.jsx)("td", {
              children: deploymentTime
            })]
          }), commitURL && shortCommitHash && (0, _jsxRuntime.jsxs)("tr", {
            children: [(0, _jsxRuntime.jsx)("td", {
              children: "Commit:"
            }), (0, _jsxRuntime.jsx)("td", {
              children: (0, _jsxRuntime.jsx)("a", {
                href: "".concat(commitURL),
                children: shortCommitHash
              })
            })]
          })]
        }), contextComment && (0, _jsxRuntime.jsx)("p", {
          children: contextComment
        }), (0, _jsxRuntime.jsx)("hr", {})]
      }), (0, _jsxRuntime.jsx)(_.Buttons.Text, {
        onClick: function onClick() {
          setShowInfo(!showInfo);
        },
        children: showInfo ? 'Hide deployment info' : 'Show deployment info'
      })]
    })
  });
};

var _default = DeploymentInfo;
exports["default"] = _default;